import React from "react";
import UserLayout from "../Layouts/UserLayout";

const Artists = () => {
  return (
    <UserLayout>
      <div>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Consequuntur
        perspiciatis iste accusantium laboriosam incidunt distinctio et magni
        provident. Tempore similique eos in incidunt nesciunt minus unde eveniet
        harum! Veniam quo ratione deserunt quas tenetur perspiciatis ea dolorum
        ut dolores delectus repudiandae, totam nostrum, architecto praesentium
        modi sint corrupti labore tempora! Possimus vero aliquam explicabo
        iusto? Porro recusandae dolores inventore perspiciatis illum nemo
        quaerat? Molestias nostrum perferendis voluptatum eveniet cupiditate
        ullam ad minima voluptate similique fugiat mollitia nisi excepturi
        inventore suscipit impedit officiis magnam, debitis, voluptates amet,
        itaque nulla autem perspiciatis rem? Accusantium magnam molestiae velit
        atque aspernatur eum, quo quaerat?
      </div>
    </UserLayout>
  );
};

export default Artists;
